import React from 'react'
import PropTypes from 'prop-types'
import { HashLink } from 'react-router-hash-link'
import SVG from 'react-inlinesvg'
import HTMLParser from 'react-html-parser'

import { startsWithHttp } from 'helpers/strings'

import './CardInfoWithIcon.scss'

function CardInfoWithIcon({ id, title, icon, linkType, ctaText, description, url, theme, slide, wrapper=false }) {
  const isLinkTypeReduced = linkType === 'reduced'

  return (
    <HashLink className="card-icon" id={id} to={url || '#'} title={title}>
      <div className={`card-icon__content type-${theme}`}>
        {icon && <SVG className="card-icon__icon" src={icon} />}
        <p className={`card-icon__title ${wrapper ? '' : `max-line-${slide ? '4' : '5'}`} ${isLinkTypeReduced && 'title-bold'}`}>{title}</p>
        <span className={`card-icon__description ${wrapper ? '' : `max-line-${slide ? '3' : '5'}`}`}>{HTMLParser(description)}</span>
        <p className={`card-icon__link ${wrapper ? '' : 'max-line-4'}`}>
          {!isLinkTypeReduced && <span className="mr-2">{ctaText}</span>}
          <i className={startsWithHttp(url) ? 'icone-diagonal-arrow-right-up' : 'icone-arrow-right'} />
        </p>
      </div>
    </HashLink>
  )
}

CardInfoWithIcon.propTypes = {
  ctaText: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.string,
  linkType: PropTypes.string,
  slide: PropTypes.bool,
  url: PropTypes.string,
  theme: PropTypes.string,
  title: PropTypes.string,
  wrapper: PropTypes.bool
}

CardInfoWithIcon.defaultProps = {
  wrapper: false,
}

export default CardInfoWithIcon
